<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="m-5">
    <div class="content-wrapper">
        <h1 class="display-1 mb-5"
            i18n>
            Policies
        </h1>
        <div class="d-flex mb-4">
            <button class="btn btn-info ml-auto btn-size-normal "
                    [routerLink]="['./', 'add-policy']">
                <span class="btn-inner--text"
                      i18n>Add New Policy</span>
            </button>
        </div>

        <section class="col-xl-0 p-0">
            <app-data-table-ajax #dataTableAjax
                                 url="/policies"
                                 limit="25"
                                 responseKey="policies"
                                 [columns]="columns"
                                 [template]="rowDetails"
                                 [extendRow]="true"
                                 (rowClicked)="onSelectRow($event)">

                <ng-template #inUseColumnTemplate
                             let-value="value">
                    <span *ngIf="value > 0"
                          class="badge badge-success"
                          i18n>In Use</span>
                </ng-template>

                <ng-template #actionColumnTemplate
                             let-row="row"
                             let-value="value">

                    <button i18n
                            type="button"
                            class="btn btn-link p-0 m-0 mr-3"
                            (click)="onEditRow($event, row)">
                        <img class="row-icon"
                             src="assets/_ionicons_svg_md-list-box.svg" />
                    </button>
                    <button i18n
                            type="button"
                            class="btn btn-link p-0 m-0"
                            (click)="handleRemoveButton($event, value)">
                        <img alt="Delete Group"
                             title="Delete Group"
                             class="row-icon"
                             src="assets/_ionicons_svg_md-trash.svg" />
                    </button>
                </ng-template>

            </app-data-table-ajax>
        </section>
    </div>
</div>

<ng-template #rowDetails
             let-row="row">
    <div class="p-4">
        <app-data-table-ajax url="/policies/{{row.id}}"
            limit="20"
            [displaySearch]="false"
            [rowHeight]="undefined"
            responseKey="statement"
            [columns]="statementsColumns">
        </app-data-table-ajax>
    </div>


</ng-template>

<ng-template #statementActions
             let-row="row">
    {{ actionsFormat(row.actions) }}
</ng-template>


// WEBPACK FOOTER //
// ./src/app/access-management/policies/policies-list/policies-list.component.html